document.addEventListener("DOMContentLoaded", function () {
  const finalResearchLink = document.getElementById("final-research");
  const finalResearchHover = document.querySelector(".final-research-hover");
  const finalResearchDefault = document.querySelector(
    ".final-research-default",
  );

  if (!finalResearchLink || !finalResearchHover) return;

  let svg = null;
  let isHovering = false;

  // Reset state when page is restored from bfcache (back/forward navigation)
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) {
      // Page was restored from bfcache - reset everything
      resetToDefaultState();
    }
  });

  // Also reset on visibility change (covers additional edge cases)
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible" && !isHovering) {
      resetToDefaultState();
    }
  });

  // Reset when window loses focus (e.g., link opens in new tab)
  window.addEventListener("blur", function () {
    resetToDefaultState();
  });

  // Also reset when window regains focus (backup for returning to tab)
  window.addEventListener("focus", function () {
    if (!isHovering) {
      resetToDefaultState();
    }
  });

  function resetToDefaultState() {
    // Remove any orphaned SVG elements from DOM directly
    const orphanedSvg = document.querySelector(".final-research-corner-lines");
    if (orphanedSvg) {
      orphanedSvg.remove();
    }
    removeCornerLines();
    hideHoverState();
    isHovering = false;
  }

  // Check if device is mobile/touch
  function isMobile() {
    return window.innerWidth <= 724 || "ontouchstart" in window;
  }

  function createCornerLines() {
    // Remove existing SVG if any
    if (svg) {
      svg.remove();
    }

    // Use requestAnimationFrame to ensure CSS hover state has applied
    requestAnimationFrame(() => {
      const rect = finalResearchHover.getBoundingClientRect();
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      // Screen corners
      const screenCorners = [
        { x: 0, y: 0 },
        { x: viewportWidth, y: 0 },
        { x: 0, y: viewportHeight },
        { x: viewportWidth, y: viewportHeight },
      ];

      // Text block corners
      const blockCorners = [
        { x: rect.left, y: rect.top },
        { x: rect.right, y: rect.top },
        { x: rect.left, y: rect.bottom },
        { x: rect.right, y: rect.bottom },
      ];

      // Create SVG element
      svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("class", "final-research-corner-lines");
      svg.style.cssText = `
        position: fixed;
        inset: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        z-index: 2147483647;
        overflow: visible;
      `;
      svg.setAttribute("viewBox", `0 0 ${viewportWidth} ${viewportHeight}`);
      svg.setAttribute("preserveAspectRatio", "none");
      svg.setAttribute("aria-hidden", "true");

      // Create lines from each screen corner to corresponding text block corner
      screenCorners.forEach((screenCorner, i) => {
        const line = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "line",
        );
        line.setAttribute("x1", screenCorner.x);
        line.setAttribute("y1", screenCorner.y);
        line.setAttribute("x2", blockCorners[i].x);
        line.setAttribute("y2", blockCorners[i].y);
        line.setAttribute("stroke", "#ef9b00");
        line.setAttribute("stroke-width", "1");
        svg.appendChild(line);
      });

      // Add viewport border
      const rect_top = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "rect",
      );
      rect_top.setAttribute("x", "0");
      rect_top.setAttribute("y", "0");
      rect_top.setAttribute("width", viewportWidth);
      rect_top.setAttribute("height", "1.5");
      rect_top.setAttribute("fill", "#ef9b00");
      svg.appendChild(rect_top);

      const rect_bottom = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "rect",
      );
      rect_bottom.setAttribute("x", "0");
      rect_bottom.setAttribute("y", viewportHeight - 1.5);
      rect_bottom.setAttribute("width", viewportWidth);
      rect_bottom.setAttribute("height", "1.5");
      rect_bottom.setAttribute("fill", "#ef9b00");
      svg.appendChild(rect_bottom);

      const rect_left = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "rect",
      );
      rect_left.setAttribute("x", "0");
      rect_left.setAttribute("y", "0");
      rect_left.setAttribute("width", "1.5");
      rect_left.setAttribute("height", viewportHeight);
      rect_left.setAttribute("fill", "#ef9b00");
      svg.appendChild(rect_left);

      const rect_right = document.createElementNS(
        "http://www.w3.org/2000/svg",
        "rect",
      );
      rect_right.setAttribute("x", viewportWidth - 1.5);
      rect_right.setAttribute("y", "0");
      rect_right.setAttribute("width", "1.5");
      rect_right.setAttribute("height", viewportHeight);
      rect_right.setAttribute("fill", "#ef9b00");
      svg.appendChild(rect_right);

      document.body.appendChild(svg);
    });
  }

  function removeCornerLines() {
    if (svg) {
      svg.remove();
      svg = null;
    }
  }

  function showHoverState() {
    if (finalResearchDefault) {
      finalResearchDefault.style.visibility = "hidden";
    }
    if (finalResearchHover) {
      finalResearchHover.style.opacity = "1";
      finalResearchHover.style.visibility = "visible";
    }
  }

  function hideHoverState() {
    // Clear inline styles to let CSS handle hover states again
    if (finalResearchDefault) {
      finalResearchDefault.style.visibility = "";
    }
    if (finalResearchHover) {
      finalResearchHover.style.opacity = "";
      finalResearchHover.style.visibility = "";
    }
  }

  // Handle mobile tap - show animation for 1.5s then navigate
  finalResearchLink.addEventListener("click", function (e) {
    if (isMobile()) {
      e.preventDefault();

      // Show hover state and corner lines
      showHoverState();
      createCornerLines();

      // After 1 second, navigate to the link (don't reset state - let navigation happen)
      setTimeout(() => {
        // Use location.href instead of window.open to avoid popup blockers
        window.location.href = finalResearchLink.href;
      }, 1000);
    }
  });

  // Desktop hover event listeners
  finalResearchLink.addEventListener("mouseenter", function () {
    if (!isMobile()) {
      isHovering = true;
      createCornerLines();
    }
  });

  finalResearchLink.addEventListener("mouseleave", function () {
    if (!isMobile()) {
      isHovering = false;
      removeCornerLines();
    }
  });

  // Update lines on scroll/resize while hovering
  window.addEventListener("resize", () => {
    if (isHovering && svg) {
      createCornerLines();
    }
  });

  window.addEventListener(
    "scroll",
    () => {
      if (isHovering && svg) {
        createCornerLines();
      }
    },
    { passive: true },
  );
});
